import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllLotteryBrands = createAsyncThunk(
  "lotteries/getAllLotteryBrands",
  async ({ skip, limit, search, status }, { rejectWithValue }) => {
    try {
      const params = {};
      if (skip !== undefined) params.skip = skip;
      if (limit !== undefined) params.limit = limit;
      if (search) params.search = search;
      if (status) params.status = status;

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/lottery-brands/get-active-lottery-brands`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          response: {
            data: {
              message: "Network Error",
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || "An error occurred"
        );
      }
    }
  }
);

export const addNewLotteryBrand = createAsyncThunk(
  "lotteries/addNewLotteryBrand",
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", lotteryData.name);
      formData.append("code", lotteryData.code);
      formData.append("logo", lotteryData.logo);
      formData.append("sample", lotteryData.sampleImage);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/lottery-brands/create-lottery-brand`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred.");
      }
    }
  }
);

export const editLotteryBrand = createAsyncThunk(
  "lotteries/editLotteryBrand",
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("id", lotteryData.id);

      if (lotteryData.name) {
        formData.append("name", lotteryData.name);
      }
      if (lotteryData.code) {
        formData.append("code", lotteryData.code);
      }
      if (lotteryData.logo) {
        formData.append("logo", lotteryData.logo);
      }
      if (lotteryData.sampleImage) {
        formData.append("sample", lotteryData.sampleImage);
      }
      if (lotteryData.status !== undefined) {
        formData.append("status", lotteryData.status);
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      };
      const response = await axios.put(
        `${PUBLIC_BASE_URL}/lottery-brands/update-lottery-brand-info`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred.");
      }
    }
  }
);

